import {
  Box,
  Group,
  List,
  ListItem,
  rem,
  ScrollArea,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core"
import {
  IconBulb,
  IconExternalLink,
  IconMail,
  IconUser,
} from "@tabler/icons-react"
import { Button } from "@tfg/ui"
import { useNavigate } from "react-router-dom"

import { InlineBanner } from "~/components/InlineBanner"
import { LaunchTraceabilityResponse } from "~/pages/Admin/Ingestion/ProductImport/hooks/useLaunchTraceabilityMutation"

type Props = {
  launchInfo: LaunchTraceabilityResponse | undefined
  handleClose: () => void
}
export function TraceabilitySuccessStats({ launchInfo, handleClose }: Props) {
  const navigate = useNavigate()

  return (
    <Stack>
      <InlineBanner
        type="success"
        message="Traceability launched successfully"
        closable={false}
      >
        <Stack gap="xs">
          <Title order={6} c="green.9">
            Launch Stats
          </Title>

          <Group align="center">
            <IconBulb size={20} color="var(--mantine-color-green-9" />
            <Text size="sm">
              <strong>Number of IRs created:</strong> {launchInfo?.irCount}
            </Text>
          </Group>
          <Stack>
            <Group align="center">
              <IconMail size={20} color="var(--mantine-color-green-9" />
              <Text size="sm" fw="bold">
                Emails sent to:
              </Text>
            </Group>
            <List
              pl="lg"
              icon={
                <ThemeIcon color="green.5" size={24} radius="xl">
                  <IconUser style={{ width: rem(16), height: rem(16) }} />
                </ThemeIcon>
              }
            >
              <ScrollArea w="100%">
                <Box mah={200} w="100%">
                  {launchInfo?.supplierEmails.map((email) => (
                    <ListItem key={email}>
                      <Text key={email} size="sm">
                        {email}
                      </Text>
                    </ListItem>
                  ))}
                </Box>
              </ScrollArea>
            </List>
          </Stack>
        </Stack>
      </InlineBanner>
      <Group w="100%">
        <Button
          rightSection={<IconExternalLink />}
          flex={1}
          onClick={() => navigate("/products")}
        >
          View Products
        </Button>
        <Button flex={1} variant="secondary" onClick={() => handleClose()}>
          Close
        </Button>
      </Group>
    </Stack>
  )
}
